exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".creation-container {\n    display: flex;\n    margin-bottom: 12px;\n}\n\n.creation-container .form-group{\n    margin: 0;\n}\n\n.attribute-name {\n    flex-grow: 1;\n}\n\n.attribute-type {\n    width: 158px;\n    margin: 0 8px;\n}\n\n.add-button {\n    padding: 0;\n    background-color: initial !important;\n}\n\n.add-button:hover, .add-button:disabled {\n    background-color: initial !important;\n}", ""]);

// exports
